function injectStyle (ssrContext) {
  require("!!../../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-6e4b3e86\",\"scoped\":true,\"hasInlineConfig\":false}!stylus-loader?sourceMap!./edit.styl")
}
var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./edit.js"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6e4b3e86\",\"hasScoped\":true}!./edit.html"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6e4b3e86",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/pages/withNavigation/purchase/edit/edit.vue
// module id = 2851
// module chunks = 1